import React, {useEffect, useMemo, useState} from 'react';
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import {Link} from "react-router-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import EnhancedTable from "./agentsTableComponent/EnhancedTable";
import AgentService from "../../../services/AgentService";
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Spinner from "reactjs-simple-spinner";


//main function
const Agents = (props) => {


    const columns = useMemo(
        () => [
            {
                Header: 'Name',
                accessor: 'name',
            },
            {
                Header: 'Surname',
                accessor: 'surname',
            },
            {
                Header: 'Agent Code',
                accessor: 'agent_code',
            },
            {
                Header: 'Telephone',
                accessor: 'contact_number',
            },
            {
                Header: 'Channel',
                accessor: 'channel',
            },
            {
                Header: 'Manager',
                accessor: 'manager',
            },
            {
                Header: 'Team',
                accessor: 'team',
            },
            {
                Header: 'Agent Type',
                accessor: 'agent_type',
            },
            {
                Header: 'Aggregator',
                accessor: 'aggregator_name',
            },
            {
                Header: 'Action',
                accessor: 'id',
                Cell: ({value}) => (
                    <span>
                        <Link className="btn btn-sm btn-primary " onClick={() => openClients(value)}>Clients <i
                            className="fa fa-book"/></Link>
                        <span> </span>
                        <Link className="btn btn-sm btn-primary" onClick={() => openEditForm(value)}>Edit <i
                            className="fa fa-edit"/></Link>
                    </span>
                )
            },
        ],
        []
    )


    //open clients
    const openClients = (value) => {
        console.log(value);
        //store row record into localStorage
        localStorage.setItem('agentId', JSON.stringify(value));
        props.history.push('/agent-clients');

    }
    //open edit form
    const openEditForm = (value) => {
        //store row record into localStorage
        localStorage.setItem('agentId', JSON.stringify(value));
        props.history.push('/edit-agent');
    }

    const [data, setData] = useState([])
    const [skipPageReset, setSkipPageReset] = useState(false)
    const [loading, setLoading] = useState(false);

    // We need to keep the table from resetting the pageIndex when we
    // Update data. So we can keep track of that flag with a ref.

    // When our cell renderer calls updateMyData, we'll use
    // the rowIndex, columnId and new value to update the
    // original data
    const updateMyData = (rowIndex, columnId, value) => {
        // We also turn on the flag to not reset the page
        setSkipPageReset(true)
        setData(old =>
            old.map((row, index) => {
                if (index === rowIndex) {
                    return {
                        ...old[rowIndex],
                        [columnId]: value,
                    }
                }
                return row
            })
        )
    }

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        setLoading(true);
        let token = JSON.parse(localStorage.getItem('token'));

        console.log("token", token)
        AgentService.getAllAgents().then(response => {
            console.log(response.agents)
            if (response !== null || response !== undefined) {
                setData(response.agents);
                setLoading(false);
            } else {
                setData([])
                setLoading(false);
            }
            setLoading(false);
        }).catch(err => {
            console.log(err);
            setData([])
            setLoading(false);
            toast.warning('Operation Failed, Reload Page\nIf error persists contact System Administrator ')
        });

    }, []);

    return (
        <div>
            <ToastContainer
                position="top-center"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            {loading && (
                <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                    <Spinner
                        size="large"
                        message="Loading Agents..."
                        line-fg-color="#64c3c2"
                    />
                </div>
            )}
            {!loading && (
                <div id="main-content" className="main-panel ps-container ps-theme-default">
                  <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                    <div className="content">
                        <div className="container-fluid">
                            <ul className="breadcrumb">
                                <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                                &nbsp;|&nbsp;
                                Sales Army
                            </ul>
                            <div className="row mt">
                                <Link className="btn btn-primary btn-sm"
                                      style={{marginRight: 10}} to="/managers">

                                    <span><i className="fa fa-users-cog"></i>&nbsp;VIEW MANAGERS</span>

                                </Link>
                                <div className="card col-lg-12">


                                    <div className="content-panel bg-white">
                                        <div className="responsive_table">
                                            {/*    table of Sale army*/}
                                            <CssBaseline/>
                                            <EnhancedTable
                                                columns={columns}
                                                data={data}
                                                setData={setData}
                                                updateMyData={updateMyData}
                                                skipPageReset={skipPageReset}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Agents;
